'use client';

import Conditional from '@next-app/components/Conditional';
import { isBrowser } from '@next-app/utils/common-utils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  selectFeatureToggles,
  selectIsGSAUser,
  selectIsSessionInfoAvailable,
} from '@next-app/lib/features/InitSelectors';
import Script from 'next/script';
import React from 'react';
import deviceType from '@next-app/utils/get-device-type';
type IApplePayEnabled = {
  children: React.JSX.Element;
  showApplePay: boolean;
  isCheckoutPage: boolean;
};
export default function ApplePayEnabled(props: IApplePayEnabled) {
  const [showApplePayStatus, setShowApplePayStatus] = useState(false);
  const featureToggle = useSelector(selectFeatureToggles);
  const isSessionInfoAvailable = useSelector(selectIsSessionInfoAvailable);
  const { applePayEnabled = false } = featureToggle || {};

  const [loadAppleSDK, setLoadAppleSDK] = useState(false);
  const [appleSDKLoaded, setAppleSDKLoaded] = useState(false);
  const [isAppleSdkAvailable, setIsAppleSdkAvailable] = useState(false);
  const device = deviceType();

  const isGSAUser = useSelector(selectIsGSAUser);
  useEffect(() => {
    if (isBrowser()) {
      if (applePayEnabled) {
        setIsAppleSdkAvailable(
          typeof (window as any).ApplePaySession !== 'undefined',
        );
        if (props.isCheckoutPage) {
          setShowApplePayStatus(applePayEnabled && props.showApplePay);
          setLoadAppleSDK(
            typeof (window as any).ApplePaySession === 'undefined' &&
              device === 'desktop',
          );
        } else {
          const updatedShowApplePayStatus =
            applePayEnabled &&
            props.showApplePay &&
            typeof (window as any).ApplePaySession !== 'undefined' &&
            !(window as any).ApplePaySDK &&
            (window as any).ApplePaySession.canMakePayments();
          setShowApplePayStatus(updatedShowApplePayStatus);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSessionInfoAvailable]);
  return (
    <>
      <Conditional if={showApplePayStatus && !isGSAUser}>
        <>
          <Conditional if={loadAppleSDK}>
            <Script
              src="https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js"
              onReady={() => {
                setAppleSDKLoaded(true);
              }}
            ></Script>
          </Conditional>
          <Conditional
            if={(loadAppleSDK && appleSDKLoaded) || isAppleSdkAvailable}
          >
            <div className="col mt-0">
              <div style={{ flex: 1 }}>
                {React.cloneElement(props.children, {
                  ...props.children.props,
                  nonMacDevice: loadAppleSDK || (window as any).ApplePaySDK,
                })}
              </div>
            </div>
          </Conditional>
        </>
      </Conditional>
    </>
  );
}
